module.exports = __webpack_public_path__ + "baby_baby-shower_1.jpg";